<template>
    <div v-if="bannerData.length" class="promo-banner--container" :style="customStyle">
        <div class="promo-banner--grid" :style="bannerStyle">
            <div class="promo-banner--grid--card" v-for="(item, index) in bannerData" :key="index" @click="goTo(item.cta_url)">
                <div class="promo-banner--grid--pre-order">
                    <img class="promo-banner--grid--pre-order--image" :src="item.image" :alt="item.header"/>
                    <button class="promo-banner--grid--pre-order--button">{{ item.cta }}</button>
                </div>
                <div class="promo-banner--text-container">
                    <h6 v-if="isGift(item)" class="promo-banner--title">{{ $t('FREE_VASE_BANNER_LIMITED_OFFER') }}</h6>
                    <h6 v-else class="promo-banner--title">{{ item.header }}</h6>
                    <p v-if="isGift(item)" class="promo-banner--description">{{ $t('FREE_VASE_BANNER_COPY') }}</p>
                    <p v-else class="promo-banner--description">{{ item.body }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PromotionalBanners',
    props: {
        position: {
            type: String,
            require: true,
        },
        customStyle: {
            type: Object,
        },
        newDashboard: {
            type: Boolean,
            default: false,
        },
        bannerData: {
            type: Array,
        },
        isFreeVase: {
            type: Boolean,
        },
    },
    computed: {
        bannerStyle() {
            return this.bannerData?.length % 2 === 0 ? {} : {
                'grid-template-columns': '1fr',
            };
        },
    },
    methods: {
        goTo(path) {
            return this.$router.push(path);
        },
        isGift(item) {
            return (item?.cta_url === '/account/gifting') && this.isFreeVase;
        },
    },
};
</script>

<style lang="scss" scoped>
    .promo-banner {
        &--container {
            width: 100%;
            margin-bottom: 32px;
            padding: 0px 16px;
        }

        &--grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 32px;
            &--card {
                display: flex;
                flex-direction: column;
                align-items: center;
                min-height: 300px;
                text-align: center;
            }
            &--pre-order {
                width: 100%;
                position: relative;
                display: flex;
                flex-direction: column;
                justify-content: flex-end;
                align-items: center;
                margin-bottom: 20px;
                cursor: pointer;
                position: relative;
                &--image {
                    height: 230px;
                    width: 100%;
                    border-radius: 8px;
                    object-fit: cover;
                }

                &--button {
                    padding: 0px 10px;
                    margin-bottom: 15px;
                    min-height: 40px;
                    width: 195px;
                    background: #FFFFFF;
                    border-radius: 4px;
                    position: absolute;
                    transition: background-color .1s linear;
                    -moz-transition: background-color .1s linear;
                    -webkit-transition: background-color .1s linear;
                }

                &--button:hover {
                    transition: background-color .1s linear;
                    -moz-transition: background-color .1s linear;
                    -webkit-transition: background-color .1s linear;
                    background-color: #ECE9E8;
                }
            }
        }

        &--title {
            line-height: 24px;
        }

        &--description {
            font-size: 18px;
            font-weight: 100;
            line-height: 20px;
            margin-top: 4px;
            margin-bottom: 0px;
        }

        &--text-container {
            height: 30%;
        }
    }

    @media (max-width: 1024px) {
        .promo-banner {
            &--container {
                margin-bottom: 40px;
                padding: 0px 10px;
            }
            &--grid {
                gap: 24px;
            }
        }
    }

    @media (max-width: 768px) {
        .promo-banner {
            &--container {
                padding: 0px 6px;
            }
            &--grid {
                display: grid;
                grid-template-columns: 1fr;
                gap: 16px;
                &--card {
                    margin-bottom: 16px;
                }
            }
        }
    }
    .promo-banner--grid--card {
        cursor: pointer;
    }
</style>
